<forge-scaffold>
    <forge-toolbar slot="header" no-divider>
        <h1 class="forge-typography--heading4" slot="start">Save Grid Load Query As</h1>
    </forge-toolbar>
    <p slot="body" style="padding: var(--forge-spacing-medium);">
        <forge-text-field show-clear density="small" class="app-bar-search">
            <input type="text" tabindex="0" [(ngModel)]="newLoadQuery" (keydown)="onKeyDown($event)"
                aria-label="save grid load query" minlength="1" maxlength="100">
        </forge-text-field>
    </p>
    <forge-toolbar slot="footer">
        <command-bar slot="end" [commands]="commands"></command-bar>
    </forge-toolbar>
</forge-scaffold>